import { render, staticRenderFns } from "./RecommendRank.vue?vue&type=template&id=b4d6b1d4&scoped=true&"
import script from "./RecommendRank.vue?vue&type=script&lang=js&"
export * from "./RecommendRank.vue?vue&type=script&lang=js&"
import style0 from "./RecommendRank.vue?vue&type=style&index=0&id=b4d6b1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d6b1d4",
  null
  
)

export default component.exports